import { render, staticRenderFns } from "./QuickWAppRedirect.vue?vue&type=template&id=fe6cbf30&scoped=true"
import script from "./QuickWAppRedirect.vue?vue&type=script&lang=js"
export * from "./QuickWAppRedirect.vue?vue&type=script&lang=js"
import style0 from "./QuickWAppRedirect.vue?vue&type=style&index=0&id=fe6cbf30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6cbf30",
  null
  
)

export default component.exports